import { MapPin } from "lucide-react";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";
const ServiceAreas = () => {
  const anim = useScrollAnimation();
  return <section id="service-areas" className="section-padding bg-muted/30">
      <div ref={anim.ref} className={`container-custom transition-all duration-1000 ${anim.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Unser Servicebereich
          </h2>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-card border border-border rounded-lg p-8 hover:border-primary/50 transition-colors text-center">
            <MapPin className="w-12 h-12 text-primary mb-4 mx-auto" />
            <h3 className="text-2xl font-bold mb-3">
              Mannheim & Rhein-Neckar-Region
            </h3>
            <div className="mb-4">
              <p className="font-semibold text-foreground mb-2">Clicks DMP - Design & Media Production</p>
              <p className="text-muted-foreground">Karl-Traub-Straße 15</p>
              <p className="text-muted-foreground mb-4">68199 Mannheim</p>
            </div>
            <p className="text-muted-foreground text-lg">Mit Sitz in Mannheim, aktiv im Südwesten Deutschland und Städten wie Heidelberg, Karlsruhe, Stuttgart, Frankfurt, Mainz und Wiesbaden. Wir sind aber auch deutschlandweit verfügbar für Projekte, die uns inspirieren und herausfordern.</p>
          </div>
        </div>
      </div>
    </section>;
};
export default ServiceAreas;